import { createSelector } from 'reselect';


const getHotkeyTmpState = createSelector(
  [
    (state) => state.hotkey_template
  ],
  (state) => state
);


export const getStatusState = createSelector(
  [
    getHotkeyTmpState
  ],
  (state) => state.status || {}
);


export const getFetchingStatus = createSelector(
  [
    getStatusState
  ],
  ({ isFetching = false }) => isFetching
);


export const getSubmittingStatus = createSelector(
  [
    getStatusState
  ],
  ({ isSubmitting = false }) => isSubmitting
);


export const getErrorStatus = createSelector(
  [
    getStatusState
  ],
  ({ isError = false, errorMessage = "" }) => ({ isError, errorMessage })
);
